
import { Component, Vue, Prop } from "vue-property-decorator";

const TIPS = [
  "舌头像身体的'晴雨表'，舌苔厚腻可能是肠胃在喊'消化不良'！",
  "舌头发红像草莓？可能是身体在冒'小火苗'，该降降火啦！",
  "舌边有齿痕，像被牙齿印过的软糖，暗示脾虚，得给脾胃加加油！",
  "舌苔发白像盖了层薄雪，小心体内有寒气，多喝热水驱驱寒。",
  "舌头胖大挤得满嘴，是湿气太重，该帮身体'甩甩水'啦！",
  "舌面光滑没舌苔，像镜子一样，可能是阴虚，快给身体补补水。",
  "舌头暗红发紫，像熟透的葡萄，可能气血不畅，要多活动筋骨。",
  "舌尖红得显眼，像涂了口红，心火旺盛，试试莲子心降降火。",
  "舌苔发黄像染了色，是体内有热，喝点凉茶消消热气。",
  "舌上有裂纹，像干涸的河床，阴虚缺水，多吃滋润食物。",
  "舌根苔厚，可能是肾有问题，别熬夜，早点给肾'放个假'。",
  "舌头歪斜，要警惕！可能是脑血管在'拉警报'，及时检查。",
  "舌色淡白像白纸，气血不足，多吃红枣补补血。",
  "舌苔剥落像地图，别慌！是脾胃有点'小脾气'，慢慢调理就好。",
  "舌头震颤不停，可能是肝风内动，少生气，让情绪稳一稳。",
  "舌体僵硬不听话，说话不利索，当心脑部健康出问题。",
  "舌面有瘀斑，像被撞青的皮肤，血液循环差，多泡脚促循环。",
  "舌苔黏腻，像抹了层胶水，湿气困住脾胃，多吃薏米祛湿。",
  "舌色青紫，可能是受寒或血瘀，来碗姜汤暖暖身。",
  "舌尖凹陷，心肺功能弱，常做扩胸运动，给心肺充充电。",
  "舌边红，是肝郁化火，多出去走走，别把气憋在心里。",
  "舌体瘦小，颜色淡，气血两虚，喝点桂圆枸杞茶补补。",
  "舌苔灰黑，别吓一跳！可能是吃了染色食物，也可能是病重信号。",
  "舌根苔少，肾气不足，多吃黑色食物，给肾'加点料'。",
  "舌面干燥像沙漠，津液不足，快大口喝水润一润。",
  "舌头胖大还水汪汪，是阳虚水泛，晒晒太阳补补阳气。",
  "舌中苔少，脾胃虚弱，少吃生冷，让脾胃舒服点。",
  "舌色鲜红肿胀，可能是热毒炽盛，赶紧就医别耽误。",
  "舌面布满红点，像撒了芝麻，体内有热，吃点苦瓜清清火。",
  "舌诊只是参考，身体不舒服别瞎猜，及时看医生才靠谱！",
];

const HEALTH_TIPS = [
  '泡脚像给脚做"温泉SPA"，驱寒又助眠，水温别太烫！',
  '多搓耳朵，像给全身"按遥控器"，促进气血循环，活力满满。',
  '熬夜是身体"透支卡"，早睡早起，给五脏六腑"充个满格电"。',
  '晒太阳好比"免费补阳"，晒晒后背，阳气蹭蹭往上涨！',
  '久坐是健康"慢性杀手"，每小时起身活动，别让身体"生锈"。',
  '生气等于"往身体倒垃圾"，学会深呼吸，把坏情绪"一键清空"。',
  '晨起一杯温水，给肠胃"开闸放水"，冲走一夜"小废物"。',
  '搓搓肚子，给肠胃"做体操"，消化变好，肚子不胀气。',
  '常梳头，像给头皮"挠痒痒"，疏通经络，头发更乌黑。',
  '喝姜茶就像"体内小太阳"，驱寒暖胃，手脚不再冰冰凉。',
  '多踮脚尖，给心脏"减负"，促进下肢血液循环超简单。',
  '大笑是天然"解压药"，每天乐一乐，赶走坏心情和病痛。',
  '少吃冷饮，别让脾胃"打哆嗦"，温热饮食才是"真爱"。',
  '搓热双手捂眼睛，给眼球"做热敷"，缓解疲劳超舒服。',
  '晨起伸懒腰，唤醒全身"小懒虫"，开启元气满满的一天。',
  '多吃五谷杂粮，给身体"换营养餐"，养出好气色。',
  '睡前泡泡脚，脚底穴位"乐开花"，睡眠质量直线上升。',
  '揉按足三里，像给肠胃"请保镖"，消化功能变强啦！',
  '常踮脚走路，锻炼小腿"小马达"，提升精气神。',
  '吃红枣就像"天然补血剂"，脸色红润，气血更充足。',
  '常眨眼，给眼睛"洗个澡"，保持明亮不疲劳。',
  '喝蜂蜜水，给肠道"抹润滑剂"，排便顺畅超轻松。',
  '常拍手，激活手上"健康开关"，增强免疫力有一手。',
  '晒完太阳别吹风，防止寒气"钻空子"，养生细节要记牢。',
  '揉耳朵垂，给全身"发福利"，美容养颜还健脑。',
  '少吃油炸食品，别给身体"添负担"，清淡饮食更健康。',
  '常叩齿，牙齿"练肌肉"，坚固耐用不掉队。',
  '喝枸杞茶，给肝肾"加加油"，养生朋克必备。',
  '常耸耸肩，放松肩颈"紧绷弦"，告别酸痛超有效。',
  '中医养生是"持久战"，坚持小习惯，收获大健康！',
];

@Component
export default class TipCarousel extends Vue {
  @Prop({ required: true }) bg!: string;
  @Prop({ required: true }) loadingText!: string;
  @Prop({ required: true }) title!: string;
  @Prop({ default: "tongue" }) category!: string; //tongue 舌诊  health 健康

  private currentIndex: number = 0;
  private timer: any = null;
  private shuffledTips: string[] = [];

  get currentTip() {
    return this.shuffledTips[this.currentIndex] || "";
  }

  mounted() {
    this.shuffleTips();
    this.startCarousel();
  }

  beforeDestroy() {
    clearInterval(this.timer);
  }

  private shuffleTips() {
    const tips = this.category === "health" ? HEALTH_TIPS : TIPS;
    this.shuffledTips = [...tips].sort(() => Math.random() - 0.5);
  }

  private startCarousel() {
    this.timer = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.shuffledTips.length;
    }, 2000);
  }
}
